export default __webpack_public_path__ + "static/media/ic-kyc-details.6054c631.svg";